import React from "react";
import { useNavigate } from "react-router-dom";
import { Absence as TimeManagementListItemType } from "@myapp/contract";
import { formatDateDDMMYYYY } from "../../../../shared/helpers/date";
import { ListItem } from "../../../../shared/ui/list/ListIteam/ListItem";
import { timeManagementColumns } from "../model/constants";
import {
  getAbsenceCategoryLabel,
  ABSENCE_CATEGORY_COLOR,
  fullDayLastDate,
} from "../../../../entities/absence";
import { routes } from "../../../../shared/config/routes";

interface Props {
  item: TimeManagementListItemType;
}

function getTechnicianLabel(item: TimeManagementListItemType): string {
  if (item.technicians.length === 0) return "-";
  if (item.technicians.length === 1) return item.technicians[0].fullName;
  return `${item.technicians.length} Handwerker`;
}

export const Absence: React.FC<Props> = ({ item }) => {
  const navigate = useNavigate();
  const techLabel = getTechnicianLabel(item);
  const techTitle = item.technicians.length > 1
    ? item.technicians.map((t) => t.fullName).join(", ")
    : undefined;

  return (
    <div
      className="cursor-pointer"
      onClick={() => navigate(routes.zeitmanagement.edit(item.id))}
    >
      <ListItem columns={timeManagementColumns}>
        <ListItem.Cell title={techTitle}>{techLabel}</ListItem.Cell>
        <ListItem.Cell className="!flex flex-row items-center gap-2">
          <div
            className="h-3 w-3 rounded-full flex-shrink-0"
            style={{ backgroundColor: ABSENCE_CATEGORY_COLOR }}
          />
          <span>{getAbsenceCategoryLabel(item.category)}</span>
        </ListItem.Cell>
        <ListItem.Cell>{formatDateDDMMYYYY(item.startsAt)}</ListItem.Cell>
        {/* `endsAt` is exclusive, so show the last day covered, not the boundary. */}
        <ListItem.Cell>{formatDateDDMMYYYY(fullDayLastDate(item.endsAt))}</ListItem.Cell>
      </ListItem>
    </div>
  );
};
